<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <div class="buttom_nav">
      <!-- <div class="round"></div> -->
      <div class="nav-list">
        <router-link class="homePage navs" to="/" :class="{buttom_select:select=='btnOne'}" @click.native="changeOne()">
          <img :src="btnUrl">
          首页
        </router-link>
        <router-link class="homePage navs" to="/project" :class="{buttom_select:select=='btnTwo'}" @click.native="changeTwo()">
          <icon name="inbox" class="select_icon"></icon>
          项目
        </router-link>
        <router-link class="homePage navs" to="/createProject" :class="{buttom_select:select=='btnThree'}" @click.native="changeThree()">
          <!-- <div class="icon_wrap"><div class="icon_bg"><icon name="plus-square-o"></icon></div></div> -->
          <icon name="plus-square-o" class="select_icon"></icon>
          发布
        </router-link>
        <!-- <router-link class="msgPage navs" to="/myJobs" :class="{buttom_select:select=='btnFour'}" @click.native="changeFour()">
          <icon name="briefcase" class="select_icon"></icon>
          工作
        </router-link> -->
        <router-link class="homePage navs" to="/custom" :class="{buttom_select:select=='btnFour'}" @click.native="changeFour()">
          <!-- <icon name="service-o" class="select_icon"></icon> -->
          <!-- <van-icon name="service-o" class="select_icon" /> -->
          <img :src="urlpeo">
          客服
        </router-link>
        <router-link class="homePage navs" to="" :class="{buttom_select:select=='btnFive'}" @click.native="changeFive()">
          <icon name="user-circle" class="select_icon"></icon>
          我的
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../utiles/bus'
export default {
  name: 'app',
  components: {
    bus
  },
  data () {
    return {
      btnUrl: require('../assets/img/btns/9-1.png'),
      urlpeo: require('../assets/img/index/peo-h.png'),
      select: 'btnOne'
    }
  },
  created () {
    bus.$on('routerBus', (item) => {
      console.log(item,"123")
      this.select = item
      if(item==='btnOne'){
        this.btnUrl = require('../assets/img/btns/9-1.png')
        this.urlpeo = require('../assets/img/index/peo-h.png')
      }else{
        this.btnUrl = require('../assets/img/btns/9-2.png')
        this.urlpeo = require('../assets/img/index/peo-h.png')
      } 
    })
    
  },
  mounted(){
    if(this.STATE.state.bottomindex==='btnOne'){
      this.changeOne()
    }if(this.STATE.state.bottomindex==='btnTwo'){
      this.changeTwo()
    }if(this.STATE.state.bottomindex==='btnThree'){
      this.changeThree()
    }if(this.STATE.state.bottomindex==='btnFour'){
      this.changeFour()
    }
    if(this.STATE.state.bottomindex==='btnFive'){
      this.changeFive()
    }
  },
  methods: {
    changeOne: function () {
      this.btnUrl = require('../assets/img/btns/9-1.png')
      this.urlpeo = require('../assets/img/index/peo-h.png')
      this.select = 'btnOne'
    },
    changeTwo: function () {
      this.btnUrl = require('../assets/img/btns/9-2.png')
      this.urlpeo = require('../assets/img/index/peo-h.png')
      this.select = 'btnTwo'
    },
    changeThree: function () {
      this.btnUrl = require('../assets/img/btns/9-2.png')
      this.urlpeo = require('../assets/img/index/peo-h.png')
      this.select = 'btnThree'
      // if (this.STATE.state.loginState) {
      //   this.$router.push({path: '/createProject'})
      // } else {
      //   this.$router.push({name: 'login', params: { fromPath: '/createProject' }})
      // }
    },
    changeFour: function () {
      this.btnUrl = require('../assets/img/btns/9-2.png')
      this.urlpeo = require('../assets/img/index/peo-l.png')
      this.select = 'btnFour'
    },
    changeFive: function () {
      this.btnUrl = require('../assets/img/btns/9-2.png')
      this.urlpeo = require('../assets/img/index/peo-h.png')
      this.select = 'btnFive'
      if (this.STATE.state.loginState) {
        this.$router.push({path: '/me'})
      } else {
        this.$router.push({name: 'login', params: { fromPath: '/me' }})
      }
    }
  }
}

</script>

<style scoped>

  .buttom_nav{
    position: fixed;
    bottom:0;
    width:100%;
  }
  .nav-list{
    position:relative;
    width:100%;
    height:48px;
    background-color:#fff;
    -webkit-box-shadow:0px 10px 10px 10px #808080;
    -moz-box-shadow:0px 10px 10px 10px #808080;
    box-shadow:0px 10px 10px 10px #808080;
    z-index:3;

  }
  .round{
    width:48px;
    height:48px;
    -webkit-border-radiu:50%;
    -moz-border-radiu:50%;
    border-radius:50%;
    -webkit-box-shadow:0px 0px 10px #808080;
    -moz-box-shadow:0px 0px 10px #808080;
    box-shadow:0px 0px 10px #808080;
    position:absolute;
    top:-45%;
    left:50%;
    transform:translateX(-50%);
    -ms-transform:translateX(-50%);
    -moz-transform:translateX(-50%);
    -webkit-transform:translateX(-50%);
    -o-transform:translateX(-50%);
    z-index:2;
    background-color:#fff;
  }
  .nav-list a{
    width:20%;
    float:left;
    text-align:center;
    color:#898989;
    font-size:16px;
    text-decoration:none;
    margin-top:8px;
  }
  .fa-icon{
    display:block;
    margin:0 auto;
    color:#cdcdcd;
  }
  .icon_wrap{
    width:46px;
    height:42px;
    background-color:#fff;
    -webkit-border-radiu:50%;
    -moz-border-radiu:50%;
    border-radius:50%;
    margin:-26px auto 0;

  }
  .icon_wrap .fa-icon{
     color:#fff;
     width:30px;
     height:30px;
  }
  .icon_wrap .icon_bg{
    margin:0 auto;
    background-color:#108ee9;
    width:40px;
    height:40px;
    -webkit-border-radiu:50%;
    -moz-border-radiu:50%;
    border-radius:50%;
    padding-top:5px;
    box-sizing:border-box;
  }
  .buttom_select{
    color:#000!important;
  }
  .buttom_select .select_icon{
    color:#1979fd;
  }
  .v-modal{
  z-index: 900;
}
.homePage img{
  display: block;
  margin: 0 auto;
  width: 22px;
}
</style>



// WEBPACK FOOTER //
// bottom.vue?3bef429b